import React, { useEffect, useState } from "react";
import PlatformIcon from "../../components/common/platform-icon.jsx";
import "../../styles/captionAI.scss";

const CaptionAICard = (props) => {
  const [shownCaption, setShownCaption] = useState();
  const [shownPlatform, setShownPlatform] = useState();

  const selectPlatform = (caption) => {
    setShownCaption(caption.text);
    setShownPlatform(caption.platform);
  };

  const copyCaption = () => {
    navigator.clipboard.writeText(shownCaption);
    props.handleCopyClick();
  }

  useEffect(() => {
    setShownCaption(props.captionGroup.captions[0].text);
    setShownPlatform(props.captionGroup.captions[0].platform);
  }, [props.captionGroup]);

  return (
    <div className="captionAI-card-container">
      <div className="captionAI-caption-box">
        {props.isPlatformSpecific ? (
          <div className="platforms">
            {props.captionGroup.captions.map((cap, index) => {
              return (
                <span
                  className="platform-tag-spacer"
                  onClick={() => selectPlatform(cap)}
                  key={`platform-${index}`}
                >
                  <PlatformIcon platform={{'type': cap.platform}} classes={'captions-platform-icon ' +
                      (shownPlatform === cap.platform ? cap.platform.toLowerCase() : ' inactive-platform')}
                                styles={{'display': 'inline-block'}}/>
                </span>
              );
            })}
          </div>
        ) : (
          <div>&nbsp;</div>
        )}

        <div className="content">
          <h5 data-testid="generated-caption">{shownCaption}</h5>
          <i
            className="fa fa-fw fa-copy caption-icon"
            onClick={copyCaption}
          ></i>
          <i
            className="fa fa-fw fa-pencil caption-icon"
            onClick={() => props.editCaption(props.captionGroup)}
          ></i>
          <i
            className="fa fa-fw fa-trash caption-icon"
            onClick={() => props.deleteCaption(props.index)}
          ></i>
        </div>
      </div>
    </div>
  );
};

export default CaptionAICard;
